<template>
  <div class="cookie-bar">
    <a
      class="cookie-bar__content"
      :href="`/cookie/${lang}.html`"
      target="_blank"
      rel="noopener noreferrer"
      v-html="$translate('cookies')"
    />

    <a
      class="cookie-bar__content"
      :href="`https://www.gucci.com/documents/legal/privacy/${lang}.pdf`"
      target="_blank"
      rel="noopener noreferrer"
      v-html="$translate('privacy')"
    />
  </div>
</template>

<script>
import { getLang } from '@/scripts/utils';

export default {
  name: 'Cookie',

  data() {
    return {
      lang: getLang(),
    };
  },
};
</script>

<style lang="scss" scoped>
.cookie-bar {
  position: relative;
  font-size: 12px;
  line-height: 14px;
  color: inherit;

  a {
    color: inherit;
    text-decoration: none;
  }
}
</style>
